import { getMe, updateMyLanguage } from '../../destek/lib/destekApi';
import type { PortalCustomerProfile } from './portalAccess';

export const getCustomerProfile = () => getMe() as Promise<PortalCustomerProfile>;
export const updateCustomerLanguage = updateMyLanguage;
